import React from "react";
import { Card, Heading } from "uikit/components";
import cx from "classnames";
import styles from "./FederationSummaryCard.module.styl";
import { number, string } from "prop-types";
import IconTooltip from "uikit/components/IconTooltip/IconTooltip";

export default function FederationSummaryCard({
    organizationsCount,
    title,
    info,
    descriptionText,
}) {
    return (
        <Card borderRadius={"giant"} padding={"none"} className={cx(styles.form)}>
            <div className={styles.content} data-test-name="federation_summary">
                <div>
                    <div className={styles.heading}>
                        <Heading size={"h2"}>{title}</Heading>
                        <div className={styles.icon}>
                            <IconTooltip trigger={"hover"}>
                                <div className={styles.infoPanel}>{info}</div>
                            </IconTooltip>
                        </div>
                    </div>
                    <div className={styles.indicators}>
                        <div className={styles.federationRating}>
                            <div className={styles.indicator}>
                                <div className={styles.numerator}>{organizationsCount}</div>
                            </div>
                            <div className={styles.federationRatingTitle}>{descriptionText}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
}

FederationSummaryCard.propTypes = {
    organizationsCount: number.isRequired,
    title: string.isRequired,
    info: string.isRequired,
    descriptionText: string.isRequired,
};
